import Iconify from './iconify';

export default Iconify;
